// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"ErrorBoundary-module__visuallyHidden--vJwhf"};